import $ from 'jquery';
import { AJAX_URL } from '../config';

/**
 * Cattle Talk archive: category + press-release filters (auto-apply, no submit)
 * and a Load More button. The first page is server-rendered; this fetches
 * filtered / subsequent pages from wl_cattle_talk_archive.
 */
$(() => {
  const $grid = $('#cattle-talk-archive-grid');

  if (!$grid.length) {
    return;
  }

  const $category = $('#ct-category');
  const $press = $('#ct-press-release');
  const $loadMore = $('#cattle-talk-load-more');
  const $empty = $('#cattle-talk-archive-empty');
  const $clear = $('.cattle-talk-archive__clear');

  let page = 1;

  const updateClear = () => {
    $clear.prop('hidden', !$category.val() && !$press.is(':checked'));
  };
  updateClear();

  const request = (targetPage, append) => {
    updateClear();
    $loadMore.prop('disabled', true);

    $.post(`${AJAX_URL}wl_cattle_talk_archive`, {
      category: $category.val() || '',
      pressRelease: $press.is(':checked') ? 1 : '',
      page: targetPage,
    })
      .done((res) => {
        if (!res || !res.success) {
          return;
        }

        const { html, hasMore, found } = res.data;

        if (append) {
          $grid.append(html);
        } else {
          $grid.html(html);
        }

        page = targetPage;
        $loadMore.attr('data-page', page).prop('hidden', !hasMore);
        $empty.prop('hidden', found > 0);
      })
      .always(() => {
        $loadMore.prop('disabled', false);
      });
  };

  // Filters apply immediately; changing either resets to the first page.
  $category.on('change', () => request(1, false));
  $press.on('change', () => request(1, false));

  $loadMore.on('click', () => request(page + 1, true));

  $clear.on('click', (event) => {
    event.preventDefault();
    $category.val('');
    $press.prop('checked', false);
    $category.trigger('focus');
    request(1, false);
  });
});
